import React, {useContext} from 'react';
import {
    OmApplicationCoverCategories,
    OmApplicationCoverCategoryCard,
    OmIcon
} from '@om/component-library-react';
import OmButton from '../../../../../components/forms/OmButton';
import CoverSideDrawer from './pages/landingPage/CoverSideDrawer';
import CoverSideDrawerSelf from './pages/landingPage/CoverSideDrawerSelf';
import { DigitalFuneralContext } from './context/DigitalFuneralContext';
import LandingCoverMemberList from './pages/landingPage/LandingCoverMemberList';

const EkyireAsemApplication = ({slot}) => {

    const { toggleCoverDrawer, coverMemberListLanding, toggleMyselfCoverDrawer } = useContext(DigitalFuneralContext);

    return (
        <div slot={slot}> 
            {coverMemberListLanding.length > 0 ?
                <LandingCoverMemberList />
                :
                <OmApplicationCoverCategories>
                    <OmApplicationCoverCategoryCard slot="first">
                        <OmIcon
                            slot="icon"
                            imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blt0f93690bb13df2a7/5f61ddd6046a1b546bb1592a/direct-family-gradient.svg"
                        />
                        <span slot="title">
                        Me Alone
                        </span>
                        <span slot="button">
                            <OmButton
                                text="Add Cover"
                                type="secondary"
                                size="small"
                                onClick={() => toggleMyselfCoverDrawer()}
                            />
                        </span>
                    </OmApplicationCoverCategoryCard>

                    <OmApplicationCoverCategoryCard slot="second">
                        <OmIcon
                            slot="icon"
                            imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blteaa4e52be1a62cee/5f61ddd625f7a73d06685672/extended-family-gradient.svg"
                        />
                        <span slot="title">
                        Me &amp; My Family Members
                        </span>
                        <span slot="button">
                            <OmButton
                                text="Add Cover"
                                type="secondary"
                                size="small"
                                onClick={() => toggleCoverDrawer()}
                            />
                        </span>
                    </OmApplicationCoverCategoryCard>
                </OmApplicationCoverCategories>
            }

            <CoverSideDrawer />
            <CoverSideDrawerSelf />
        </div>
    )

}

export default EkyireAsemApplication;